import gql from 'graphql-tag';

export default gql`
  mutation updateCourseIntroStatusUserMutation(
    $scope: String!
    $completed: Boolean
    $dismissed: Boolean
    $lastStep: Int
    $firstLoginHandled: Boolean
  ) {
    updateCourseIntroStatusUserMutation(
      scope: $scope
      completed: $completed
      dismissed: $dismissed
      lastStep: $lastStep
      firstLoginHandled: $firstLoginHandled
    ) {
      message
    }
  }
`;
